document.addEventListener('DOMContentLoaded', function() {
    // Initialize Swiper
    var swiper = new Swiper('.multi-collection-tabs .mct-swiper', {
        spaceBetween: 10,
        slidesPerView: 1.30,
        grabCursor: true,
        keyboard: {
            enabled: true,
        },
        breakpoints: {
            769: {
                slidesPerView: 2,
                spaceBetween: 14,
            },
            1024: {
                slidesPerView: 3.5,
                spaceBetween: 18,
            },
            1600: {
                slidesPerView: 5,
                spaceBetween: 22,
            }
        },
        navigation: {
            nextEl: '.multi-collection-tabs .mct-pagination .swiper-button-next',
            prevEl: '.multi-collection-tabs .mct-pagination .swiper-button-prev',
        }
    });

    // Tab functionality
    const tabButtons = document.querySelectorAll('.multi-collection-tabs .mct-list li button');
    const allItems = document.querySelectorAll('.multi-collection-tabs .mct-item');

    // Function to show only items from the selected collection
    function showCollectionItems(collectionId) {
        allItems.forEach(item => {
            const itemCollectionId = item.getAttribute('data-collection-id');
            if (itemCollectionId === collectionId) {
                item.classList.remove('mct-item-hidden');
                item.style.display = 'block';
            } else {
                item.classList.add('mct-item-hidden');
                item.style.display = 'none';
            }
        });
        
        // Update Swiper after changing visibility
        setTimeout(() => {
            swiper.update();
            swiper.slideTo(0, 0); // Go to first slide
        }, 100);
    }

    // Function to update active tab state
    function updateActiveTab(activeButton) {
        tabButtons.forEach(button => {
            button.classList.remove('active');
            button.setAttribute('aria-selected', 'false');
        });
        
        activeButton.classList.add('active');
        activeButton.setAttribute('aria-selected', 'true');
    }

    // Event listeners for tabs
    tabButtons.forEach((button, index) => {
        button.addEventListener('click', function() {
            const collectionId = this.getAttribute('data-collection-id');
            
            // Update active state
            updateActiveTab(this);
            
            // Show items from selected collection
            showCollectionItems(collectionId);
        });
    });

    // Show first collection by default
    if (tabButtons.length > 0) {
        const firstTab = tabButtons[0];
        const firstCollectionId = firstTab.getAttribute('data-collection-id');
        updateActiveTab(firstTab);
        showCollectionItems(firstCollectionId);
    }
});

